// extracted by mini-css-extract-plugin
module.exports = {"notice":"ChooseSettingNotice_notice__2YbhP"};